(function () {
  'use strict';

  function initAnnounce(root) {
    var track = root.querySelector('[data-gh-announce-track]');
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll('[data-gh-announce-slide]'));
    if (slides.length < 2) {
      if (slides[0]) slides[0].classList.add('is-active');
      return;
    }
    var i = 0;
    var prev = root.querySelector('[data-gh-announce-prev]');
    var next = root.querySelector('[data-gh-announce-next]');
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    }
    show(0);
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    setInterval(function () { show(i + 1); }, 6000);
  }

  function initDropdowns(root) {
    var items = [].slice.call(root.querySelectorAll('[data-gh-dropdown]'));
    items.forEach(function (item) {
      var btn = item.querySelector('[data-gh-dropdown-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = item.classList.contains('is-open');
        items.forEach(function (x) { x.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-gh-dropdown]')) {
        items.forEach(function (x) { x.classList.remove('is-open'); });
      }
    });
  }

  function initMobile(root) {
    var mobile = root.querySelector('[data-gh-mobile]');
    var burger = root.querySelector('[data-gh-burger]');
    var close = root.querySelector('[data-gh-mobile-close]');
    var backdrop = root.querySelector('[data-gh-mobile-backdrop]');
    if (!mobile || !burger) return;
    function open() {
      mobile.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function shut() {
      mobile.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    burger.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    if (backdrop) backdrop.addEventListener('click', shut);
  }

  function init(root) {
    initAnnounce(root);
    initDropdowns(root);
    initMobile(root);
  }

  document.querySelectorAll('[data-global-header]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-global-header]');
    if (el) init(el);
  });
})();
